
  // Initialize Firebase
  export const configFire = {
    apiKey: "AIzaSyB8Oz6lnMvDwyG0eeJKfBZbi-11ZwXPjP0",
    authDomain: "bibleboom.firebaseapp.com",
    databaseURL: "https://bibleboom.firebaseio.com",
    projectId: "firebase-bibleboom",
    storageBucket: "firebase-bibleboom.appspot.com",
    messagingSenderId: "156197497863"
  };



// WEBPACK FOOTER //
// ./src/app/firebase.ts